import React, {useContext, useEffect, useState} from 'react';
import {Popover, Select, Button, message} from 'antd';
import {AxiosRequestWithImba} from "../../helpers/AxiosRequest";
import {RoleContext} from "../../contexts/RoleContext";

const { Option } = Select;

const UsersUnBan = ({record, imba_id}) => {
    const [period, setPeriod] = useState(0);
    const [visible, setVisible] = useState(false);

    const success = (text) => {
        message.success(text);
    };

    const onUnBan = (item) => {
        AxiosRequestWithImba('unban_user', {
            userId: (record.user_id) ? record.user_id : record.id,
            room_id: -1,
            ban_reason: 'admin ban',
            admin: localStorage.getItem('comet-user-id')
        }, imba_id).then((data) => {
            if (data.result>=0)
            {
                success('User successfully unban!')
                setVisible(false)
            }
        })
    }

    const handleVisibleChange = (visible) => {
        setVisible(visible)
    };

    const content = (
        <div>
            
            <Button className={'m-1'} onClick={() => onUnBan(record)}>OK</Button>
        </div>
    );

    const {getRole} = useContext(RoleContext);
    const {setRole} = useContext(RoleContext);
    const role = getRole()

    if(role !='operator'){
    return (
        <Popover visible={visible} placement="topLeft" title={'Confirm unban'} content={content} trigger={'click'} onVisibleChange={handleVisibleChange}>
            <a className={'button'} id={`ban-${record.id}`}>unban user</a>
        </Popover>
    );
    }
    else{
        return (
            <>
            </>
        );
    }
};


export default UsersUnBan;